<div *ngIf="!isError" fxlayout="column">
  <ng-container *ngIf="!isOffline">
    <h2 mat-dialog-title>{{ "uploadProgressDialog.onlineTitle" | translate }}</h2>
  </ng-container>
  <ng-container *ngIf="isOffline">
    <h2 *ngIf="!isTransfer" mat-dialog-title>{{ "uploadProgressDialog.offlineTitle" | translate }}</h2>
    <h2 *ngIf="isTransfer" mat-dialog-title>{{ "uploadProgressDialog.offlineTransferTitle" | translate }}</h2>
  </ng-container>

  <mat-dialog-content>
    <br />
    <br />
    <br />

    <ng-container *ngIf="progressMode === 'saveFile'">
      <p fxLayoutAlign="end">
        {{ (isOffline ? "uploadProgressDialog.saveFileCount" : "uploadProgressDialog.uploadFileCount") | translate }} {{ fileUploadProgress }}%({{
          completeFileCount
        }}/{{ totalFileCount }})
      </p>
      <mat-progress-bar mode="determinate" [value]="fileUploadProgress"></mat-progress-bar>
    </ng-container>

    <ng-container *ngIf="progressMode === 'directFileTransfer' || progressMode === 'receiveFile'">
      <!-- File Transfer Progress -->
      <ng-container *ngIf="!isSaveStart">
        <p fxLayoutAlign="end">
          {{ "uploadProgressDialog.receivedFileSize" | translate }}: {{ receivedFileProgress | number: "0.0-0" }}% ({{
            loadedFileSize | number: "0.0-0"
          }}
          KB / {{ totalFileSize | number: "0.0-0" }} KB)
        </p>
        <p fxLayoutAlign="end">
          <ng-container *ngIf="transferEstimatedSeconds < 0">
            {{ "uploadProgressDialog.startReceiving" | translate }}
          </ng-container>
          <ng-container *ngIf="transferEstimatedSeconds > 0">
            {{ "uploadProgressDialog.waitSeconds" | translate }}: {{ transferEstimatedSeconds | timeUnit }}
          </ng-container>
          <ng-container *ngIf="transferEstimatedSeconds === 0">
            {{ "uploadProgressDialog.saving" | translate }}
          </ng-container>
        </p>
        <mat-progress-bar mode="determinate" [value]="receivedFileProgress"></mat-progress-bar>
      </ng-container>

      <!-- File Save Progress -->
      <ng-container *ngIf="isSaveStart">
        <p fxLayoutAlign="end">
          {{ (isOffline ? "uploadProgressDialog.savedComplete" : "uploadProgressDialog.uploadFileCount") | translate }}: {{ fileUploadProgress }}%({{
            completeFileCount
          }}/{{ totalFileCount }})
        </p>
        <p fxLayoutAlign="end">
          <ng-container *ngIf="saveEstimatedSeconds < 0">
            {{ "uploadProgressDialog.startSaving" | translate }}
          </ng-container>
          <ng-container *ngIf="saveEstimatedSeconds > 0">
            {{ "uploadProgressDialog.waitSeconds" | translate }}: {{ saveEstimatedSeconds | timeUnit }}
          </ng-container>
          <ng-container *ngIf="saveEstimatedSeconds === 0">
            {{ "uploadProgressDialog.saving" | translate }}
          </ng-container>
        </p>
        <mat-progress-bar mode="determinate" [value]="fileUploadProgress"></mat-progress-bar>
      </ng-container>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button [disabled]="isDisabledCancel" mat-button color="primary" (click)="cancel()">{{ "uploadProgressDialog.cancel" | translate }}</button>
  </mat-dialog-actions>
</div>
<div *ngIf="isError" fxlayout="column">
  <h2 mat-dialog-title>
    {{ "uploadProgressDialog.error" | translate }}
  </h2>
  <div fxLayoutAlign="center center" fxlayout="column">
    <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="5px">
      <mat-dialog-content fxLayoutAlign="center start">
        <mat-icon class="top-icon" aria-label="" color="warn">error</mat-icon>
      </mat-dialog-content>
      <!-- Chrome -->
      <div *ngIf="browserFlag && !isFileWrong" fxLayoutAlign="center">
        <p *ngIf="!isOffline" id="message" class="message">
          {{ "uploadProgressDialog.message1" | translate: { successFileCount: successFileCount, fileCount: totalFileCount } }}
          <br />
          {{ "uploadProgressDialog.message2" | translate }}
        </p>
        <p *ngIf="isOffline" id="message" class="message">
          {{ "uploadProgressDialog.message3" | translate: { successFileCount: successFileCount, fileCount: totalFileCount } }}
          <br />
          {{ "uploadProgressDialog.message4" | translate }}
        </p>
      </div>
      <div class="file-name-div">
        <br />
        <p id="file-name" class="file-name">
          <ng-container *ngFor="let failedFile of imageFileResultList | keyvalue">
            <ng-container *ngIf="failedFile.value === '0'">
              <mat-icon
                class="list-icon"
                aria-label=""
                color="basic"
                [matTooltip]="'uploadProgressDialog.cancelTooltip' | translate"
                matTooltipPosition="above"
              >
                cancel</mat-icon
              >
              <font class="file-name-item">{{ failedFile.key }}</font
              ><br />
            </ng-container>
            <ng-container *ngIf="failedFile.value === '2'">
              <mat-icon
                class="list-icon"
                aria-label=""
                color="warn"
                [matTooltip]="'uploadProgressDialog.errorTooltip' | translate"
                matTooltipPosition="above"
                >error
              </mat-icon>
              <font class="file-name-item" color="red">{{ failedFile.key }}</font
              ><br />
            </ng-container>
          </ng-container>
        </p>
      </div>
      <mat-dialog-actions fxLayoutAlign="center start">
        <button mat-raised-button [mat-dialog-close]="true" color="primary">{{ "uploadProgressDialog.close" | translate }}</button>
        <button *ngIf="!isOffline" mat-button [mat-dialog-close]="true" color="primary">{{ "uploadProgressDialog.reUpload" | translate }}</button>
        <button *ngIf="isOffline" mat-button [mat-dialog-close]="true" color="primary">{{ "uploadProgressDialog.reSave" | translate }}</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>
